/** Optional dev preview: set REACT_APP_PREVIEW_METER_STOPPED=true in .env */
export const PREVIEW_METER_STOPPED_BADGE =
  process.env.REACT_APP_PREVIEW_METER_STOPPED === "true" ||
  process.env.REACT_APP_PREVIEW_METER_STOPPED === "1";

const meterStoppedOnObject = (obj) => {
  if (!obj || typeof obj !== "object") return false;

  const issue = obj.is_meter_sensor_issue;
  if (issue === 1 || issue === "1" || issue === true) return true;

  const status = obj.meter_stopped_status;
  if (status === 1 || status === "1" || status === true) return true;
  if (typeof status === "string" && /stop/i.test(status.trim())) return true;

  return false;
};

/**
 * Trip / fuel-form meter sensor: is_meter_sensor_issue 0 = OK, 1 = stopped.
 * Checks root payload and nested trip_id / trip_details / trip when present.
 */
export const isTripMeterStopped = (record) => {
  if (PREVIEW_METER_STOPPED_BADGE) return true;
  if (meterStoppedOnObject(record)) return true;

  const nested = record?.trip_id ?? record?.trip_details ?? record?.trip;
  if (nested && typeof nested === "object") {
    return meterStoppedOnObject(nested);
  }
  return false;
};
